export const loadRazorpay = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const CHECKOUT_METHOD_LABELS = {
  upi: 'UPI',
  card: 'Card',
  netbanking: 'Net Banking',
};

/** Razorpay netbanking bank codes (Dashboard must also enable each bank). */
const NETBANKING_BANKS = ['HDFC', 'ICIC', 'UTIB', 'SBIN'];

function buildCheckoutConfig(checkoutMethod) {
  if (!checkoutMethod || !CHECKOUT_METHOD_LABELS[checkoutMethod]) return undefined;

  // Netbanking: list major banks explicitly + Razorpay default list (merchant-enabled banks).
  if (checkoutMethod === 'netbanking') {
    return {
      display: {
        blocks: {
          major_banks: {
            name: 'Pay via Net Banking',
            instruments: NETBANKING_BANKS.map((bank) => ({
              method: 'netbanking',
              banks: [bank],
            })),
          },
        },
        sequence: ['block.major_banks', 'netbanking'],
        preferences: { show_default_blocks: true },
      },
    };
  }

  return {
    display: {
      blocks: {
        selected: {
          name: CHECKOUT_METHOD_LABELS[checkoutMethod],
          instruments: [{ method: checkoutMethod }],
        },
      },
      sequence: ['block.selected'],
      preferences: { show_default_blocks: false },
    },
  };
}

export const initiatePayment = async ({
  amount,
  userId,
  name,
  email,
  phone,
  description,
  checkoutMethod,
  onSuccess,
  onFailure,
}) => {
  const loaded = await loadRazorpay();
  if (!loaded) { alert('Razorpay load failed!'); return; }

  try {
    const token = localStorage.getItem('developmentexpress_token');
    const orderRes = await fetch(`${API_BASE_URL}/api/wallet/create-order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token || ''}`,
      },
      body: JSON.stringify({ amount, userId }),
    });
    const order = await orderRes.json();
    if (!orderRes.ok) throw new Error(order.error || 'Order creation failed');
    if (!order.keyId) {
      throw new Error('Payment key missing from server. Please redeploy backend.');
    }

    const options = {
      key: order.keyId,
      amount: order.amount,
      currency: 'INR',
      order_id: order.orderId,
      name: 'Development Express',
      description: description || 'Development Express Wallet Recharge',
      handler: async function (response) {
        try {
          const verifyRes = await fetch(`${API_BASE_URL}/api/wallet/verify-payment`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token || ''}`,
            },
            body: JSON.stringify({
              userId,
              orderId: response.razorpay_order_id,
              paymentId: response.razorpay_payment_id,
              signature: response.razorpay_signature,
            }),
          });
          const verifyPayload = await verifyRes.json();
          if (!verifyRes.ok) throw new Error(verifyPayload.error || 'Payment verification failed');
          onSuccess({ ...response, verification: verifyPayload });
        } catch (error) {
          if (onFailure) onFailure(error);
        }
      },
      prefill: {
        name: name || 'Customer',
        email: email || 'customer@developmentexpress.in',
        contact: phone || '8408000084'
      },
      theme: { color: '#c9a84c' },
      modal: { ondismiss: () => { if (onFailure) onFailure(); } },
    };

    const checkoutConfig = buildCheckoutConfig(checkoutMethod);
    if (checkoutConfig) {
      options.config = checkoutConfig;
    }

    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', (response) => { if (onFailure) onFailure(response.error); });
    rzp.open();
  } catch (err) {
    alert('Payment init failed: ' + err.message);
    if (onFailure) onFailure();
  }
};